import React from 'react';
import i18n from '../../i18n';
import { CircularProgress, TableCell, Typography } from '@mui/material';
import ConfirmDialog from '../dialogs/ConfirmDialog';

export default class GridEditableBoolean extends React.Component {
    state = {
        loading: false,
        value: this.props.value,
        confirmDialogOpen: false
    };

    handleToggle = async () => {
        const { id } = this.props;
        const { value } = this.state;
        this.setState({ loading: true });

        const isResp = await this.props.handleSave(id, !value);
        if (isResp) {
            this.setState({
                value: !value,
                loading: false,
                confirmDialogOpen: false
            });
        } else {
            this.setState({ loading: false, confirmDialogOpen: false });
        }
    };

    handleChange = () => {
        if (!this.props.allowEdit) {
            return;
        }
        // open a confirmation dialog
        this.setState({ confirmDialogOpen: true });
    };

    render() {
        const { value, loading } = this.state;
        const { field } = this.props;
        const confirmTrueLabel = field.confirmTrueLabel || 'confirmTrue';
        const confirmFalseLabel = field.confirmFalseLabel || 'confirmFalse';
        const baseStyle = this.props.styles;
        const allowEdit = this.props.allowEdit !== undefined ? this.props.allowEdit : false;

        return (
            <TableCell
                key={this.props.field.id}
                align="left"
                sx={{ ...baseStyle }}
            >
                <div style={{ cursor: allowEdit ? 'pointer' : 'default' }} onClick={this.handleChange}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '2px'
                        }}
                    >
                        {loading ? (
                            <CircularProgress size={20} />
                        ) : (
                            <Typography
                                color={value ? 'text.success' : 'text.error'}
                                variant="body2"
                            >
                                {value
                                    ? i18n.t(`enums.${field.trueLabel}`)
                                    : i18n.t(`enums.${field.falseLabel}`)}
                            </Typography>
                        )}
                    </div>
                </div>
                <ConfirmDialog
                    dialogOpen={this.state.confirmDialogOpen}
                    onConfirm={() => this.handleToggle()}
                    onCancel={() => {
                        this.setState({ confirmDialogOpen: false });
                    }}
                    alertText={
                        value
                            ? i18n.t(`dialogs.${confirmTrueLabel}`)
                            : i18n.t(`dialogs.${confirmFalseLabel}`)
                    }
                    alertTitle={i18n.t('dialogs.confirmationTitle')}
                />
            </TableCell>
        );
    }
}
